import type { SerializableRenderTreeNode } from '../../../../react-commons/components/data-display/tree/RenderTreeNode';

export const defaultLoadingNode: SerializableRenderTreeNode<never> = {
    key: 'LoadingTree',
    selectionDisabled: true,
    label: 'Loading',
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    data: undefined as never,
    loading: true,
};
